import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ToastService } from '../../../core/services/toast.service';
import { Store } from '@ngrx/store';
import { fromStore } from 'angular/app/core/store';
import { authActions } from 'angular/app/core/store/auth';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { ClipboardService } from 'ngx-clipboard';
import { environment } from '../../../../environments/environment';
import { VendorsService } from '../../../core/services/vendors.service';
import { FormValidationService } from '../../../core/services/form-validation.service';
import { ApiError } from '../../../core/models/common/api-error';
import { phoneValidator } from '../../../core/services/validation.service';
import { FilePondOptions } from 'filepond';
import { FileUploadComponent } from '../../../shared-manager/components/file-upload/file-upload.component';
import { SharedModule } from '../../../shared/shared.module';
import { SharedManagerModule } from '../../../shared-manager/shared-manager.module';
import { SettingsModule } from '../../settings.module';

import { FormFieldsetComponent } from '../../../shared/components/form-fieldset.component';
import { PaymentProvider } from '../../../core/models/entities/vendor';

@Component({
  selector: 'app-vendor-settings-page',
  template: `
    <app-page-header title="Organisation"></app-page-header>
    
    <app-spacer size="4"></app-spacer>
    
    @if (vendor()?.payment_provider === PaymentProvider.Payrexx) {
      <app-admin-tabs></app-admin-tabs>
    }
    
    <app-spacer size="6"></app-spacer>
    
    <form>
      <div class="border-b border-gray-200 pb-4">
        <app-fieldset>
          <div title>Coordonnées</div>
          <div description
            >Toutes les informations liées aux coordonnées de votre
            organisation, afin que les clients puissent vous contacter.
          </div>
    
          <app-text-input
            label="Nom"
            name="name"
            [control]="form.get('name')"
          ></app-text-input>
    
          <app-text-input
            label="Rue et no"
            name="address"
            [control]="form.get('address')"
          ></app-text-input>
    
          <div class="grid grid-cols-1 md:grid-cols-4 md:gap-x-6">
            <app-text-input
              label="Code postal"
              name="zip"
              [control]="form.get('zip')"
            ></app-text-input>
    
            <app-text-input
              label="Localité"
              name="city"
              [control]="form.get('city')"
              class="col-span-3"
            ></app-text-input>
          </div>
    
          <div class="grid grid-cols-1 md:grid-cols-2 md:gap-x-6">
            <app-text-input
              label="Adresse e-mail"
              name="email"
              [control]="form.get('email')"
            ></app-text-input>
    
            <app-phone-input
              #phoneInput
              label="No de téléphone"
              name="phone"
              [control]="form.get('phone')"
            ></app-phone-input>
          </div>
        </app-fieldset>
      </div>
    
      <div class="border-b border-gray-200 pt-12 pb-8">
        <app-fieldset>
          <div title>Informations de facturation</div>
          <div description
            >Les informations de facturation sont utilisées pour générer les
            factures.
          </div>
    
          <app-text-input
            [control]="form.controls['iban']"
            name="iban"
            label="IBAN"
            />
    
          <app-text-input
            label="N° de TVA"
            name="vat"
            [control]="form.get('vat')"
          ></app-text-input>
        </app-fieldset>
      </div>
    
      <div class="border-b border-gray-200 pt-12 pb-8">
        <app-fieldset>
          <div title>Logo</div>
          <div description
            >Votre logo s'affichera sur votre page publique, les e-mails de
            confirmation et les factures.
          </div>
    
          <app-file-upload
            #logoUploadCmp
            [config]="logoUploadConfig"
            [defaultFiles]="
              currentUser()?.vendor?.logo_url
                ? [currentUser()?.vendor?.logo_url]
                : []
            "
          ></app-file-upload>
        </app-fieldset>
      </div>
    
      <div class="border-b border-gray-200 pt-12 pb-8">
        <app-fieldset>
          <div title>Conditions générales</div>
          <div description
            >Vous pouvez importer ici un document au format PDF de vos
            conditions générales. Le client sera amené à accepter ces conditions
            générales pour pouvoir valider sa demande de réservation. Ces
            conditions générales sont valables pour toutes les salles, sauf pour
            celles où des conditions spéciales ont été ajoutées dans le menu de
            gestion de la salle.</div
            >
    
            <app-file-upload
              #generalTermsUploadCmp
              [config]="generalTermsUploadConfig"
            [defaultFiles]="
              currentUser()?.vendor?.general_terms_public_url
                ? [currentUser()?.vendor?.general_terms_public_url]
                : []
            "
            ></app-file-upload>
          </app-fieldset>
        </div>
    
        <div class="border-b border-gray-200 py-12">
          <app-fieldset>
            <div title>Lien de partage</div>
            <div description
              >Partagez ce lien pour que vos clients puissent réserver en ligne.
            </div>
    
            <div class="bg-light rounded-lg p-8">
              @if (!editingUrl) {
                <div
                  class="flex items-center gap-4"
                  >
                  <div
                    >{{ host }}/louer-salle/{{ currentUser()?.vendor?.slug }}
                  </div>
                  <app-icon-action
                    data-cy="copy-link-button"
                    icon="link"
                    (click)="copyLink()"
                  ></app-icon-action>
                  <app-icon-action
                    data-cy="edit-link-button"
                    icon="pen"
                    (click)="editingUrl = true"
                  ></app-icon-action>
                </div>
              } @else {
                <div class="block items-center justify-between md:flex">
                  <div class="flex items-center gap-x-4">
                    <div>{{ host }}/louer-salle/</div>
                    <app-text-input
                      [control]="form.get('slug')"
                      name="slug"
                      [marginTop]="false"
                      [marginBottom]="false"
                    ></app-text-input>
                  </div>
                  <div class="mt-4 flex justify-end">
                    <app-button variant="link" (click)="cancelUrlEdition()"
                      >Annuler
                    </app-button>
                  </div>
                </div>
              }
    
            </div>
          </app-fieldset>
        </div>
    
        <div class="mt-8 flex justify-end">
          <app-button
            data-cy="save-button"
            [loading]="sendingData"
            icon="check"
            variant="secondary"
            (click)="submit()"
            >Enregistrer
          </app-button>
        </div>
      </form>
    `,
  imports: [
    SharedModule,
    SharedManagerModule,
    SettingsModule,
    FormFieldsetComponent
],
})
export class VendorSettingsPageComponent implements OnInit {
  @ViewChild('logoUploadCmp') logoUploadCmp: FileUploadComponent;
  @ViewChild('generalTermsUploadCmp')
  generalTermsUploadCmp: FileUploadComponent;
  @ViewChild('phoneInput') phoneInput: ElementRef;
  currentUser = this.store.selectSignal(fromStore.selectAuthUser);
  vendor = this.store.selectSignal(fromStore.selectAuthVendor);
  form: FormGroup;
  sendingData = false;
  editingUrl = false;
  readonly logoUploadConfig: Partial<FilePondOptions> = {
    className: 'single-col',
    allowMultiple: false,
    maxFileSize: '1MB',
    acceptedFileTypes: [
      'image/png',
      'image/jpeg',
      'image/svg+xml',
      'image/webp',
    ],
    labelIdle: `
        <div>
          <i class="fal fa-file-image"></i>
          <div class="font-sans text-secondary-500">Faites glisser votre logo ici <br>ou <span class="underline cursor-pointer">téléchargez-le depuis votre appareil</span>.</div>
        </div>
      `,
  };
  readonly generalTermsUploadConfig: Partial<FilePondOptions> = {
    className: 'single-col',
    allowMultiple: false,
    acceptedFileTypes: ['application/pdf'],
    onactivatefile: () => {
      if (
        this.currentUser().vendor.general_terms_public_url &&
        typeof this.generalTermsUploadCmp.files[0] === 'string'
      ) {
        window.open(
          this.currentUser().vendor.general_terms_public_url,
          '_blank',
        );
      }
    },
    labelIdle: `
        <div>
          <i class="fal fa-file-pdf"></i>
          <div class="font-sans text-secondary-500">Faites glisser les conditions générales ici <br>ou <span class="underline cursor-pointer">téléchargez-les depuis votre appareil</span>.</div>
        </div>
      `,
  };

  constructor(
    private toastService: ToastService,
    private store: Store,
    private clipboardService: ClipboardService,
    private vendorsService: VendorsService,
    private formValidationService: FormValidationService,
  ) {}

  ngOnInit() {
    const user = this.currentUser();
    this.form = new FormGroup({
      name: new FormControl(user.vendor.name, [Validators.required]),
      address: new FormControl(user.vendor.address ?? ''),
      zip: new FormControl(user.vendor.zip ?? ''),
      city: new FormControl(user.vendor.city ?? ''),
      vat: new FormControl(user.vendor.vat ?? ''),
      phone: new FormControl(user.vendor.phone ?? ''),
      email: new FormControl(user.vendor.email ?? ''),
      slug: new FormControl(user.vendor.slug, [Validators.required]),
      iban: new FormControl(user.vendor.iban ?? ''),
    });
  }

  ngAfterViewInit() {
    this.form.get('phone').setValidators([phoneValidator(this.phoneInput)]);
  }

  get host() {
    return new URL(environment.appUrl).host;
  }

  async submit() {
    const user = this.currentUser();

    if (!this.formValidationService.validate(this.form)) return;
    this.sendingData = true;
    try {
      const vendor = await this.vendorsService.update({
        ...this.form.value,
        logo:
          typeof this.logoUploadCmp.files[0] === 'string'
            ? null
            : this.logoUploadCmp.files[0],
        delete_logo: !!(
          this.logoUploadCmp.files.length === 0 && user.vendor.logo_url
        ),
        general_terms:
          typeof this.generalTermsUploadCmp.files[0] === 'string'
            ? null
            : this.generalTermsUploadCmp.files[0],
        delete_general_terms: !!(
          this.generalTermsUploadCmp.files.length === 0 &&
          user.vendor.general_terms_public_url
        ),
      });

      this.toastService.success('Modifications enregistrées.');
      this.store.dispatch(
        authActions.findCurrentUserSuccess({ user: { ...user, vendor } }),
      );
      this.form.patchValue({
        name: vendor.name,
        slug: vendor.slug,
      });

      this.editingUrl = false;
    } catch (exception) {
      this.formValidationService.displayApiValidationErrors(
        this.form,
        exception as ApiError,
      );
    }
    this.sendingData = false;
  }

  copyLink() {
    const user = this.currentUser();

    this.clipboardService.copy(
      `${environment.appUrl}/louer-salle/${user.vendor.slug}`,
    );
    this.toastService.success('Lien copié dans le presse-papiers.');
  }

  cancelUrlEdition() {
    const user = this.currentUser();

    this.editingUrl = false;
    this.form.get('slug').patchValue(user.vendor.slug);
  }

  protected readonly PaymentProvider = PaymentProvider;
}
